"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUnknownDef = void 0;
const any_js_1 = require("./any.js");
function parseUnknownDef(refs) {
    return (0, any_js_1.parseAnyDef)(refs);
}
exports.parseUnknownDef = parseUnknownDef;
